module.exports = __webpack_public_path__ + "img/nullData.1c605b3b.png";